import { Route } from "@angular/router"
import { DashboardComponent } from "./ui/dashboard/dashboard.component"

const dashboardRoutes: Route[] = [
    {
      path: 'dashboard',
      children: [
        {
          path: '',
          component: DashboardComponent
        }
      ]
    }
  ]
  
  export default dashboardRoutes